export function currentClimateMonth(date = new Date()): number {
  return Number(
    new Intl.DateTimeFormat("en", {
      month: "numeric",
      timeZone: "Europe/Copenhagen",
    }).format(date),
  );
}

export function initialClimateMonths(
  month: number,
  desktop: boolean,
): number[] {
  if (!Number.isInteger(month) || month < 1 || month > 12) return [];
  return Array.from(
    { length: desktop ? 3 : 1 },
    (_, offset) => ((month - 1 + offset) % 12) + 1,
  );
}
